import { MutationTree } from 'vuex';
import {
  AdmissionState,
  AdmissionType,
  EvaluationEnem,
  EvaluationSecondGraduation,
  EvaluationTransferGraduation,
  Institution,
} from './state';
import { EvaluationStatus } from '@/pipeline/stateMachine';

const mutations: MutationTree<AdmissionState> = {
  SET_ADMISSION_ID(state, admissionId: number) {
    state.admissionId = admissionId;
  },
  SET_ADMISSION_TYPE(state, admissionType: AdmissionType) {
    state.admissionType = admissionType;
  },
  SET_AVAILABLE_ADMISSION_TYPES(state, availableAdmissionTypes: AdmissionType[]) {
    state.availableAdmissionTypes = availableAdmissionTypes;
  },
  SET_AVAILABLE_ENEM_YEARS(state, availableEnemYears: string[]) {
    state.availableEnemYears = availableEnemYears;
  },
  SET_ENEM(state, enem: EvaluationEnem) {
    state.enem = { ...state.enem, ...enem };
  },
  SET_EVALUATION_STATUS(state, evaluationStatus: EvaluationStatus) {
    state.evaluationStatus = evaluationStatus;
  },
  SET_SECOND_GRADUATION(state, secondGraduation: EvaluationSecondGraduation) {
    state.secondGraduation = { ...state.secondGraduation, ...secondGraduation };
  },
  SET_TRANSFER_GRADUATION(state, transferGraduation: EvaluationTransferGraduation) {
    state.transferGraduation = { ...state.transferGraduation, ...transferGraduation };
  },
  SET_AVAILABLE_INSTITUTIONS(state, availableInstitutions: Institution[]) {
    state.availableInstitutions = availableInstitutions;
  },
};

export default mutations;
